<template>
	<div>
		<div v-for="(item,index) in data" :key="index">
			<p class="title"> {{item.name}}接口</p>
			<p>（1）接口基本信息：</p>
			<el-table :data="item.data1" border>
				<el-table-column prop="name" label="名称" width="180">
				</el-table-column>
				<el-table-column prop="info" label="接口信息" width="1000">
				</el-table-column>
			</el-table>
			<p>（2）请求参数说明：</p>
			<el-table :data="item.data2" border>
				<el-table-column prop="name" label="参数" width="180">
				</el-table-column>
				<el-table-column prop="is" label="必填" width="180">
				</el-table-column>
				<el-table-column prop="info" label="参数描述" width="1000">
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				data: [
					{
					name: '1.sendMsg',
					data1: [{

							name: '方法简介',
							info: '发送消息'
						},
						{

							name: '方法调用',
							info: '方法调用	ImClient::sendMsg($toId,$msg="",$toType=1)'
						},
						
					],
					data2: [
					{
						is:1,
						name: 'msg',
						info: '消息文本(自定义文本格式)'
					},
					 {
					 	is:1,
					 	name: 'toid',
					 	info: '接收人UID'
					 },
					 {
					 	is:0,
					 	name: 'totype',
					 	info: '1 用户消息（默认） 2 群组消息'
					 },
					 ],
				},
				{
					name: '2.joinGroup',
					data1: [{
				
							name: '方法简介',
							info: '加入群聊，先前已经加入过的群聊将被忽略'
						},
						{
				
							name: '方法调用',
							info: 'ImClient::joinGroup($uid,$groupId)'
						},
					],
					data2: [
					{
						is:1,
						name: 'uid',
						info: '用户id'
					},
					 {
					 	is:1,
					 	name: 'groupid',
					 	info: '群聊ID，多个则用英文逗号分隔'
					 },
					 ],
				},
				{
					name: '3.leaveGroup',
					data1: [{
				
							name: '方法简介',
							info: '执行用户退出群聊'
						},
						{
				
							name: '方法调用',
							info: 'ImClient::leaveGroup($uid,$groupId)'
						},
					],
					data2: [
					{
						is:1,
						name: 'uid',
						info: '用户id'
					},
					 {
					 	is:1,
					 	name: 'groupid',
					 	info: '群聊ID，多个则用英文逗号分隔'
					 },
					 ],
				},
				{
					name: '4.ungroup',
					data1: [{
				
							name: '方法简介',
							info: '根据群聊号（批量）解散群聊'
						},
						{
				
							name: '方法调用',
							info: 'ImClient::ungroup($groupId)'
						},
						{
				
							name: '请求方式',
							info: 'POST'
						},
					],
					data2: [
					 {
					 	is:1,
					 	name: 'groupid',
					 	info: '群聊ID，多个则用英文逗号分隔'
					 },
					 ],
				},
				{
					name: '5.addFriends',
					data1: [{
				
							name: '方法简介',
							info: '为用户将新的好友添加到聊天好友列表'
						},
						{
				
							name: '方法调用',
							info: 'ImClient::addFriends($uid,$friendId)'
						},
					],
					data2: [
					{
						is:1,
						name: 'uid',
						info: '用户id'
					},
					 {
					 	is:1,
					 	name: 'friendid',
					 	info: '用户的好友ID列表，多个则用英文逗号分隔(本接口适用于不允许白名单外用户收发消息的场景)'
					 },
					 ],
				},
				{
					name: '6.removeFriends',
					data1: [{
				
							name: '方法简介',
							info: '为用户移除拟解除好友关系的聊天好友'
						},
						{
				
							name: '方法调用',
							info: 'ImClient::removeFriends'
						},
					],
					data2: [
					{
						is:1,
						name: 'uid',
						info: '用户id'
					},
					 {
					 	is:1,
					 	name: 'friendid',
					 	info: '用户的好友ID列表，多个则用英文逗号分隔(本接口适用于不允许白名单外用户收发消息的场景)'
					 },
					 ],
				},
				{
					name: '7.addBlacklist',
					data1: [{
				
							name: '方法简介',
							info: '为用户将新的黑名单用户添加到黑名单列表'
						},
						{
				
							name: '方法调用',
							info: 'ImClient::addBlacklist($uid,$blacklistId)'
						},
					],
					data2: [
					 {
					 	is:1,
					 	name: 'uid',
					 	info: '用户id'
					 },
					 {
					 	is:1,
					 	name: 'blacklistid',
					 	info: '用户的黑名单用户列表ID列表，多个则用英文逗号分隔'
					 },
					 ],
				},
				{
					name: '8.removeBlacklist',
					data1: [{
				
							name: '方法简介',
							info: '为用户移除黑名单用户列表'
						},
						{
				
							name: '方法调用',
							info: 'ImClient::removeBlacklist($uid,$blacklistId)'
						},
					],
					data2: [
					 {
					 	is:1,
					 	name: 'uid',
					 	info: '用户id'
					 },
					 {
					 	is:1,
					 	name: 'blacklistid',
					 	info: '用户的黑名单用户列表ID列表，多个则用英文逗号分隔'
					 },
					 ],
				},
				{
					name: '9.deleteUserOAuthToken',
					data1: [{
				
							name: '方法简介',
							info: '删除用户OAuth认证信息'
						},
						{
				
							name: '方法调用',
							info: 'ImClient::deleteUserOAuthToken($uid)'
						},
					],
					data2: [
					 {
					 	is:1,
					 	name: 'uid',
					 	info: '用户id'
					 },
					 ],
				},
				{
					name: '10.deleteUserOAuthToken',
					data1: [{
				
							name: '方法简介',
							info: '检查IM服务器请求客户端回调等场景携带来的sign签名参数是否正确'
						},
						{
				
							name: '方法调用',
							info: 'ImClient::checkSign($timestamp,$sign)'
						},
					],
					data2: [
					 {
					 	is:1,
					 	name: 'timestamp',
					 	info: '用户idIM服务器向客户端请求携带的timestamp参数'
					 },
					 {
					 	is:1,
					 	name: 'sign',
					 	info: 'IM服务器向客户端请求携带的sign参数'
					 },
					 ],
				},
				
				]
			}
		}
	}
</script>

<style scoped="scoped">
	.title {
		font-size: 20px;
		font-weight: 600;
	}

	p {
		width: 80%;
	}
</style>
